// This file contains utility functions to flatten analysis rows
// So that we can easily access problem and warning counts within the json data structure


// Export all problem and warning keys as constants
// This allows us to maintain a single source of truth for these keys

export const problemKeys = [
  "address_only_numbers",
  "address_with_potential_url",
  "address_with_url",
  "expected_name_equals_address",
  "google_plus_code",
  "housing_related_business_category_id",
  "missing_address",
  "missing_business_category_id",
  "missing_city",
  "missing_coordinates",
  "missing_country_code",
  "missing_name",
  "missing_postal_code",
  "missing_reverse_geocode_country_code",
  "name_equals_address",
  "name_equals_generic_value",
  "name_has_invalidating_string",
  "name_has_profanity",
  "name_has_repeated_characters",
  "name_includes_google",
  "name_only_numbers",
  "name_with_potential_url",
  "nonstandard_state",
  "outside_city",
  "outside_country",
  "outside_shapefile",
  "outside_state",
  "scrubbed_address_equals_neighborhood",
  "scrubbed_address_with_emoji",
  "scrubbed_address_with_url",
  "scrubbed_name_equals_scrubbed_address",
  "scrubbed_name_has_generic_my_value",
  "scrubbed_name_has_invalidating_string",
  "scrubbed_name_has_profanity",
  "scrubbed_name_has_unicode_characters",
  "scrubbed_name_has_unusual_characters",
  "scrubbed_name_has_vertical_pipe_characters",
  "scrubbed_name_includes_google",
  "scrubbed_name_very_long",
  "scrubbed_name_with_emoji",
  "scrubbed_name_with_potential_url",
  "scrubbed_name_with_url",
  "unexpected_name_equals_address",
  "unnamed_road",
  "unnamed_road_google_code_combo",
  "website_contains_google",
  "wrong_country",
  "wrong_reverse_geocode_country",
] as const;


export const warningKeys = [
  "address_very_long",
  "address_very_short",
  "address_with_unicode_chars",
  "address_with_unusual_chars",
  "name_overlaps_address",
  "name_very_long",
  "name_very_short",
  "name_with_unicode_chars",
  "name_with_unusual_chars",
] as const;


// Extracts problem and warning keys from a row object
export const extractProblemWarningKeys = (row: any) => ({
  problemKeys: Object.keys(row?.problems ?? {}),
  warningKeys: Object.keys(row?.warnings ?? {}),
});

// Flattens the analysis rows by extracting problem and warning counts
// showing total, unreviewed, and reviewed counts for each key
export const flattenAnalysisRows = (rows: any[]) =>
  rows.map((row) => {
    const flat: any = { ...row };

    problemKeys.forEach((key) => {
      const item = row.problems?.[key];
      flat[`problems_${key}_total`] = item?.total ?? 0;
      flat[`problems_${key}_unreviewed`] = item?.unreviewed ?? 0;
      flat[`problems_${key}_reviewed`] = item?.reviewed ?? 0;
    });

    warningKeys.forEach((key) => {
      const item = row.warnings?.[key];
      flat[`warnings_${key}_total`] = item?.total ?? 0;
      flat[`warnings_${key}_unreviewed`] = item?.unreviewed ?? 0;
      flat[`warnings_${key}_reviewed`] = item?.reviewed ?? 0;
    });

    return flat;
  });
